import React, { Component } from "react";
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn,
	RaisedButton
} from "material-ui";
import { connect } from "react-redux";
import _ from "lodash";
import Util, { SUCCESS } from "../../../common/Util";
import VerticalListFields from "../../../components/VerticalListFields/VerticalListFields";
import AddSalaryDialogForm from "./AddSalaryDialogForm";
import { actionChangeEmpresaProps } from "../../../actions/EmpresaActions";
import { actionGetContributions } from "../../../actions/AfiliadoActions";
import {
	actionChangeSalaryProps,
	actionDeleteSalary
} from "../../../actions/SalaryActions";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE
} from "../../../actions/ActionConstants";
import OptionsTableRowColumn from "../../../components/OptionsTableRowColumn/OptionsTableRowColumn";
import AppMem from "../../../common/AppMem";
import { SALARY_TYPE_HABERES } from "../../../common/Constants";

class ContributionsTab extends Component {
	constructor(props) {
		super(props);
		this.state = { openSalaryDialog: false };
	}

	handleEdit(contribution) {
		if (contribution) {
			this.props.actionChangeSalaryProps({
				modeCRU: MODE_CRU_UPDATE,
				salary: contribution
			});
			this.setState({ openSalaryDialog: true });
		}
	}

	handleDelete(idSalary) {
		AppMem.confirmDialog.open({
			title: "Anular Aporte",
			messageConfirm: "¿Esta seguro que desea anular el aporte?",
			onAccept: () =>
				this.props.actionDeleteSalary(idSalary, this.callbackDelete.bind(this))
		});
	}

	callbackDelete(status) {
		if (status === SUCCESS) {
			Util.showNoty(SUCCESS, "Aporte eliminado exitosamente");
			this.props.actionGetContributions(this.props.afiliado.affiliateNumber);
		}
	}

	renderBodyRows(contributionsList) {
		return _.map(contributionsList, (contribution, i) => {
			return (
				<TableRow key={i} style={{ height: "18px", fontSize: "14px" }}>
					<TableRowColumn style={{ width: "9%" }}>
						{contribution.month}
					</TableRowColumn>
					<TableRowColumn style={{ width: "9%" }}>
						{contribution.year}
					</TableRowColumn>
					<TableRowColumn style={{ width: "17%" }}>
						{`$ ${Util.formatDouble(contribution.amount)}`}
					</TableRowColumn>
					<TableRowColumn style={{ width: "65%" }}>
						{contribution.companyName}
					</TableRowColumn>
					<TableRowColumn style={{ width: "8%" }}>
						{contribution.source}
					</TableRowColumn>
					{contribution.source === SALARY_TYPE_HABERES ? (
						<TableRowColumn style={{ width: "13%" }}>
							<OptionsTableRowColumn
								handleEdit={() => this.handleEdit(contribution)}
								handleDelete={() => this.handleDelete(contribution.id)}
							/>
						</TableRowColumn>
					) : (
						<TableRowColumn style={{ width: "13%" }} />
					)}
				</TableRow>
			);
		});
	}
	render() {
		return (
			<div>
				<div className="text-right top20 bottom10">
					<RaisedButton
						label="Consultar DDJJs como NO Afiliado"
						primary
						style={{ margin: 5 }}
						onClick={this.props.checkContriByCUIL}
						disabled={
							this.props.modeCRU === MODE_CRU_CREATE &&
							this.props.personCuil &&
							!this.props.personCuil.includes("_")
								? false
								: true
						}
					/>
					<RaisedButton
						label="Cargar Aportes"
						primary
						style={{ margin: 5 }}
						disabled={this.props.modeCRU === MODE_CRU_CREATE ? true : false}
						onClick={() => {
							this.setState({ openSalaryDialog: true });
							this.props.onOpenAddSalary();
							this.props.actionChangeSalaryProps({
								modeCRU: MODE_CRU_CREATE,
								salary: null
							});
						}}
					/>
				</div>
				<VerticalListFields
					titleText="Datos de los Aportes"
					titleClass="title-papercard-primary"
					paperClass="papercard top10 bottom20"
					contentClass="content-papercard-around"
				>
					<div>
						<Table selectable={false}>
							<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
								<TableRow>
									<TableHeaderColumn style={{ width: "9%" }}>
										Mes
									</TableHeaderColumn>
									<TableHeaderColumn style={{ width: "9%" }}>
										Año
									</TableHeaderColumn>
									<TableHeaderColumn style={{ width: "17%" }}>
										Importe
									</TableHeaderColumn>
									<TableHeaderColumn style={{ width: "65%" }}>
										Empresa
									</TableHeaderColumn>
									<TableHeaderColumn style={{ width: "8%" }}>
										Origen
									</TableHeaderColumn>
									<TableHeaderColumn style={{ width: "13%" }} />
								</TableRow>
							</TableHeader>
							<TableBody stripedRows displayRowCheckbox={false}>
								{!_.isEmpty(this.props.contributionsList) &&
								!this.props.contributionsList.affiliateNumber
									? this.renderBodyRows(this.props.contributionsList)
									: null}
							</TableBody>
						</Table>
					</div>
				</VerticalListFields>
				<AddSalaryDialogForm
					open={this.state.openSalaryDialog}
					onRequestClose={() => {
						this.props.actionChangeEmpresaProps({ empresa: null });
						this.setState({ openSalaryDialog: false });
					}}
				/>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		modeCRU: store.afiliado.modeCRU,
		afiliado: store.afiliado.afiliado
	};
}

export default connect(
	mapStateToProps,
	{
		actionChangeEmpresaProps,
		actionChangeSalaryProps,
		actionDeleteSalary,
		actionGetContributions
	}
)(ContributionsTab);



// WEBPACK FOOTER //
// ./src/screens/Afiliado/Tabs/ContributionsTab.js